import React from 'react';

const ContactSupport = () => <div>ContactSupport Component</div>;

export default ContactSupport;
